import PageWrapper from "@/components/layout/PageWrapper";
import { META } from "@/config/constants";
import { Hero } from "@/components/sections/Hero/Hero";
import { Recognition } from "@/components/sections/Recognition/Recognition";
import { Trust } from "@/components/sections/Trust/Trust";
import { Bento3 } from "@/components/sections/Bento/Bento3";
import { TestimonialCarousel } from "@/components/sections/Testimonials/TestimonialCarousel";
import { CTA } from "@/components/sections/CTA/CTA";
import HowItWorks from "@/components/sections/HowItWorks";
import Carousel from "@/components/sections/Carousel/Carousel";
import Infrastructure from "@/components/sections/Infrastructure/Infrastructure";
import Bento8 from "@/components/sections/Bento8/Bento8";
import HSIntegrations from "@/components/sections/HSIntegrations/HSIntegrations";
import { CloudTabDisplay } from "@/components/sections/CloudTabDisplay";
import {
  carouselItems,
  testimonials,
  infrastructureFeatures,
  bentoItemsData,
  integrationApps,
  bentoItems,
  trustLogos,
  recognitionBadges,
  homeData
} from "@/config/homeData";

const Home = () => {
  return (
    <PageWrapper
      title={META.HOME.TITLE}
      description={META.HOME.DESCRIPTION}
      keywords={["integrations", "embedded iPaaS", "SaaS connectivity", "white-labeled integrations"]}
    >
      <Hero
        tag={homeData.hero.tag}
        title={<>{homeData.hero.title}</>}
        description={<div dangerouslySetInnerHTML={{ __html: homeData.hero.description }} />}
        cta={homeData.hero.cta}
      />

      {/* Carousel Section */}
      <Carousel items={carouselItems} />

      {/* Recognition Section 1 */}
      <Recognition
        tag={homeData.recognition.excellence.tag}
        title={homeData.recognition.excellence.title}
        description={homeData.recognition.excellence.description}
        badges={recognitionBadges.excellence}
      />

      {/* Trust Section */}
      <Trust
        title={homeData.trust.title}
        logos={trustLogos}
      />

      {/* Bento3 Section */}
      <Bento3
        title={homeData.bento.title}
        description={homeData.bento.description}
        items={bentoItems}
      />

      {/* Infrastructure Section */}
      <Infrastructure
        tag={homeData.infrastructure.tag}
        title={homeData.infrastructure.title}
        description={homeData.infrastructure.description}
        features={infrastructureFeatures}
      />

      {/* How It Works Section */}
      <HowItWorks />

      {/* Bento8 Section (formerly Use Cases) */}
      <Bento8
        tag={homeData.useCases.tag}
        title={homeData.useCases.title}
        description={homeData.useCases.description}
        bentoItems={bentoItemsData}
        demoSection={homeData.useCases.demoSection}
      />

      <HSIntegrations
        apps={integrationApps}
        tag={homeData.hsIntegrations.tag}
        title={homeData.hsIntegrations.title}
        subtitle={homeData.hsIntegrations.subtitle}
        buttonText={homeData.hsIntegrations.buttonText}
      />

      {/* Testimonials Section with integrated Impact */}
      <TestimonialCarousel
        testimonials={testimonials}
        backgroundColor={homeData.testimonialCarousel.backgroundColor}
        textColor={homeData.testimonialCarousel.textColor}
        showActionButton={homeData.testimonialCarousel.showActionButton}
        actionButton={homeData.testimonialCarousel.actionButton}
        impactSection={homeData.testimonialCarousel.impactSection}
      />

      {/* Recognition Section 2 */}
      <Recognition
        tag={homeData.recognition.security.tag}
        title={homeData.recognition.security.title}
        description={homeData.recognition.security.description}
        learnMoreHref={homeData.recognition.security.learnMoreHref}
        badges={recognitionBadges.security}
      />

      {/* Cloud Deployment Options */}
      <CloudTabDisplay
        tag={homeData.cloudTabDisplay.tag}
        title={homeData.cloudTabDisplay.title}
        description={homeData.cloudTabDisplay.description}
      />

      {/* CTA Section */}
      <CTA
        title={homeData.cta.title}
        description={homeData.cta.description}
        cta={homeData.cta.cta}
      />
    </PageWrapper>
  );
};

export default Home;
